import React from "react";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "../ui/chart";
import { AccentColor } from "@/helpers/types";
import { CardContent, CardHeader } from "../ui/card";
import {
  PolarRadiusAxis,
  RadialBar,
  RadialBarChart,
  TooltipProps,
} from "recharts";
import { BiSolidHelpCircle } from "react-icons/bi";

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "../ui/hover-card";

const CustomRadialTooltip: React.FC<TooltipProps<number, string>> = ({
  active,
  payload,
}) => {
  if (!active || !payload?.length) return null;

  return (
    <div className="rounded bg-[#0f172a] px-2 py-1 shadow text-xs text-white">
      {payload.map((entry, index) => (
        <div
          key={index}
          className="flex items-center justify-between gap-2 mb-1 last:mb-0"
        >
          <div className="flex items-center gap-2">
            <span
              className="w-3 h-3 rounded-sm"
              style={{ backgroundColor: entry.color }}
            />
            <span className="text-gray-300">{entry.name}</span>
          </div>
          <span className="font-semibold text-white">{entry.value}%</span>
        </div>
      ))}
    </div>
  );
};

const RadialChart: React.FC<{
  t: any;
  backtestGraphRes: any;
  title: string;
  hint?: string;
  totalTrades?: number;
}> = ({ title, t, backtestGraphRes = {}, hint, totalTrades = null }) => {
  //
  let backtestGraphResModified =
    backtestGraphRes.length > 1
      ? [
          {
            [backtestGraphRes[0]?.name]: backtestGraphRes[0]?.value,
            [backtestGraphRes[1]?.name]: backtestGraphRes[1]?.value,
          },
        ]
      : [];

  return (
    <div className="w-full h-full radialChartMarketplace">
      <CardHeader className=" items-center text-sm text-center font-semibold tracking-tight pt-0 pb-0 h-[20%]">
        <div className="text-[12px] flex items-center mt-0 pt-0">
          {title}
          {hint && (
            <HoverCard openDelay={100}>
              <HoverCardTrigger asChild>
                <span>
                  <BiSolidHelpCircle size={12} />
                </span>
              </HoverCardTrigger>
              <HoverCardContent>{hint}</HoverCardContent>
            </HoverCard>
          )}
        </div>
      </CardHeader>

      <CardContent className="flex flex-col p-0  items-center mt-[5%]">
        <div className="flex w-full h-full">
          <ChartContainer config={{}} className="w-full h-full">
            <RadialBarChart
              data={backtestGraphResModified}
              startAngle={180}
              endAngle={0}
              innerRadius={"90%"}
              outerRadius={"160%"}
            >
              <ChartTooltip cursor={false} content={<CustomRadialTooltip />} />
              <PolarRadiusAxis tick={false} tickLine={false} axisLine={false} />

              <text
                x="50%"
                y="41%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="fill-foreground text-sm font-bold"
              >
                {totalTrades
                  ? totalTrades
                  : backtestGraphRes?.reduce(
                      (item: any, acc: any) => item.value + acc.value
                    )}
                <tspan
                  x="50%"
                  dy="1.5em"
                  className="fill-muted-foreground text-sm"
                >
                  {t("Total Trades")}
                </tspan>
              </text>

              <RadialBar
                dataKey={backtestGraphRes[0]?.name} // Make sure this data key matches your data
                cornerRadius={3} // Rounded corners
                fill={AccentColor.GREEN} // Use your preferred color
                className=""
                stackId="a"
              />
              <RadialBar
                dataKey={backtestGraphRes[1]?.name} // Make sure this data key matches your data
                cornerRadius={3} // Rounded corners
                fill="var(--foreground-red)" // Use your preferred color
                className=""
                stackId="a"
              />
            </RadialBarChart>
          </ChartContainer>
        </div>
      </CardContent>
    </div>
  );
};
export default RadialChart;
